//import React from 'react';
import React, { Component} from 'react'
import {Cell,Grid} from 'react-md'
import MathJax from '../../components/react-mathjax-preview'
import LoadingSpinner from '../../components/LoadingSpinner'
import MathParserUtil from '../../lib/math-parser'
import {replaceImageWidth, createVideoLinkIframe} from '../../common/functions'

//CSS Import
import '../../css/AnswerTypeRadiobutton.css'

const checkBoxOneColumnSize = 1;
const checkBoxValueOneColumnSize = 11;

const checkBoxTwoColumnSize = 1;
const checkBoxValueTwoColumnSize = 5;

const AnswerTypeRadiobutton = function (props) {
 
  
  let handleClickContent = function(index) {
    let radioElement = document.getElementById('radio'+index);
    if(radioElement !== undefined && radioElement !== null)
    radioElement.click();
  }
        let handleClick = function(id,index) {


        if(props.onAnswerChoice !== undefined)
            props.onAnswerChoice(id,index);
      }

      let checkBoxSizeDesktop;
            let checkBoxValueSizeDesktop;

            if(props.numOfColumns   ===  2){
                checkBoxSizeDesktop =  checkBoxTwoColumnSize;
                checkBoxValueSizeDesktop    =   checkBoxValueTwoColumnSize;
            }else
            {
                checkBoxSizeDesktop         =  checkBoxOneColumnSize;
                checkBoxValueSizeDesktop    =   checkBoxValueOneColumnSize;
            }

            let  answerDisplayArray      =   [];
            let selectedAnswer =props.selectedAnswers;
            if (props.displayAnswerArr !== undefined &&
               props.displayAnswerArr !== null &&
               props.displayAnswerArr !== "") {

                    answerDisplayArray  =  props.displayAnswerArr.map((answerArr, cIndex) => {
                        if(answerArr.answer_text !== undefined && answerArr.answer_text !== null && answerArr.answer_text !== ""){
                        let checkBox =
                          <input 
                           name  =   'AnswerTypeRadio'
                           id={'radio'+cIndex}
                    onChange={()=>handleClick(answerArr.answer_id.toString(),cIndex)}
                    type='radio' value={answerArr.answer_id.toString()}
                    style={{marginLeft:"1em",marginRight:"0.5em"}}

                     checked={selectedAnswer === answerArr.answer_id.toString() ? true: false}/>
                     ;
                    if(answerArr.isChecked === true )
                    {
                        checkBox=
                          <input 
                          id={'radio'+cIndex}
                           name  =   'AnswerTypeRadio' checked
                           onChange={()=>handleClick(answerArr.answer_id.toString(),cIndex)} 
                            type='radio'
                            value={answerArr.answer_id.toString()}
                            style={{marginLeft:"1em",marginRight:"0.5em"}}
                            />

                        }                 
                    var ansTxt = answerArr.answer_text.toString('html',null).replace("<p><br></p>", "").replace("<p><br></p>", "")
                    if(props.currentQuestionType === 1){
                      ansTxt = MathParserUtil.computeFormula(ansTxt,props.currentVariableMap,answerArr.answer_display_options);
                    }
                    //if(props.numOfColumns == 2){
                      ansTxt = replaceImageWidth(props,ansTxt)
                    //}
                    //console.log('ansText',ansTxt);
                    // if(answerArr.hasOwnProperty('is_answer') &&    answerArr.is_answer == 1){
                    //   ansTxt = "Answer:" + ansTxt;
                    // }

                    let content   =   React.createElement(MathJax,{"math":ansTxt});
                    return  <Cell   key={cIndex+'Radio'}
                                size={checkBoxSizeDesktop} phoneSize={1} tabletSize={2}
                                onClick={()=>handleClickContent(cIndex)}
                                className='answer-type-radio-button-container'
                                size={checkBoxValueSizeDesktop} phoneSize={3} tabletSize={6} >
                                    {checkBox}
                                <label style={{marginTop: "-5px",marginLeft:"0.5em"}} htmlFor={'radio'+cIndex}>{content}{ansTxt !== null ? createVideoLinkIframe(ansTxt):''}</label>
                                </Cell>
                            ;
                        }
                }
                );

            }

    if (props.displayAnswerArr !== undefined &&props.displayAnswerArr.length > 0)
        return <Grid>
                {answerDisplayArray}
        </Grid>
        else
        return <LoadingSpinner/>


}

export default AnswerTypeRadiobutton;
